/**
 * LatencyBar Component
 * Visualizes latency relative to thresholds
 */

import React from 'react';
import { DependencyKey, HealthStatus } from '../types';
import { getLatencyPercentage } from '../helpers/statusCalculators';
import styles from '../SystemHealth.module.css';

interface LatencyBarProps {
  dependencyKey: DependencyKey;
  latencyMs: number;
  status: HealthStatus;
}

export const LatencyBar: React.FC<LatencyBarProps> = ({
  dependencyKey,
  latencyMs,
  status
}) => {
  const percentage = getLatencyPercentage(dependencyKey, latencyMs);

  const statusClass = {
    healthy: styles.barHealthy,
    degraded: styles.barDegraded,
    error: styles.barError,
    loading: styles.barLoading
  }[status];

  return (
    <div className={styles.latencyBar}>
      <div 
        className={`${styles.latencyBarFill} ${statusClass}`}
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};

export default LatencyBar;
